var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectFloor162(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2500,
    height: 1270,
    viewBox: "0 0 2500 1270",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: 2,
    d: "M745.5 594.5L819.5 593.5V407.5H1073V56.5H568V277H217V675H451.5H573.5V608H745.5V594.5Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: 4,
    d: "M898 535H820V486V407.5H1073V56.5H1133H1240.5H1328V146V154.5V535H1242.5H1203H1002.5H898Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: 7,
    d: "M1505.5 535H1328V155.5V140.5V104.5H1575.5V406H1598.5H1661.5H1819V517.5H1749V562.5H1586V535H1522H1505.5Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: 8,
    d: "M1975.5 591H2016V606H2075V675.5H2346V708.5V737.5V785V840V1024.5H2080.5H1815.5V923H1833V669H1819V591H1898H1975.5Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: 10,
    d: "M1512.5 535H1586V562.5H1749V608H1651V674H1583.5V1024.64H1328V535H1497H1502.5H1512.5Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: 9,
    d: "M217 935V675H447.5H573.5V608H663H745.5V594.5H819.5V923H833.5V1025H567.5H302.5V935H217Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: 3,
    d: "M900.5 607V535H1328V1025H1063V672H997.5V607H900.5Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: 1,
    d: "M1819 591V406H1575.5V104.5H1828.5V78.5H2345V241.5H2395.5V351.5H2444.5V728.5H2398V839.5H2346V675.5H2075V606H2016V591H1819Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectFloor162);
export default __webpack_public_path__ + "static/media/select-floor-16_2.3435952c.svg";
export { ForwardRef as ReactComponent };